'use client';
import { useRouter } from 'next/navigation';
import { useEffect, useState, useRef } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { StatGetDeviceId } from 'eco-design-micro/EcoStat/config';
import cookie from 'react-cookies';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';

import { getIsPadWidth } from '@elem/utils/devices';
import EFBundlesCardAI from '@elem/ui/ef-bundles-card-AI';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import styles from '../../index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { getGloProductList } from '@/appSetting/get-global-data/getGloProductList';
import { getGloAIProductList } from '@/appSetting/get-global-ai/getGloAIProductList';
import gtm from '@/utils/gtm';
import generateTraceId from '@/utils/singUtil/generateTraceId';
import { loginUser } from '@/utils/cookie';
import { getRewardUserInfo, getRewardUserLevel, getAIUserInfo, queryShopifyProductList } from '@/service/vip';
import { getIsLogin } from '@/utils/cookie';
import { searchRes, bundlesRes, productRes2 } from './mock';

const WEB_HOST = process.env.NEXT_PUBLIC_WEB_HOST;

const i18nText: any = {
    en: {
        search_delete: 'Delete',
        site_nav_search: 'Search Ecoflow.com',
        site_nav_search_recommend: 'Recommendations',
        site_nav_search_recommend_bundle: 'Recommend Bundles',
        search_empty: 'No content～',
    },
    de: {
        search_delete: 'Löschen',
        site_nav_search: 'EcoFlow.com durchsuchen',
        site_nav_search_recommend: 'Empfehlungen',
        site_nav_search_recommend_bundle: 'Empfohlene Bundles',
        search_empty: 'Kein Inhalt～',
    },
    fr: {
        search_delete: 'Supprimer',
        site_nav_search: 'Rechercher sur EcoFlow.com',
        site_nav_search_recommend: 'Recommandations',
        site_nav_search_recommend_bundle: 'Lots recommandés',
        search_empty: 'Aucun contenu～',
    },
    it: {
        search_delete: 'Elimina',
        site_nav_search: 'Cerca su EcoFlow.com',
        site_nav_search_recommend: 'Raccomandazioni',
        site_nav_search_recommend_bundle: 'Bundle consigliati',
        search_empty: 'Nessun contenuto～',
    },
    es: {
        search_delete: 'Eliminar',
        site_nav_search: 'Cerca su EcoFlow.com',
        site_nav_search_recommend: 'Recomendaciones',
        site_nav_search_recommend_bundle: 'Paquetes recomendados',
        search_empty: 'Sin contenido～',
    },
    kr: {
        search_delete: 'Delete',
        site_nav_search: '검색하기 Ecoflow.com',
        site_nav_search_recommend: '추천 검색어',
        site_nav_search_recommend_bundle: '추천 상품 묶음',
        search_empty: '콘텐츠 없음',
    },
    jp: {
        search_delete: '削除',
        site_nav_search: '製品名などを入力してください',
        site_nav_search_recommend: 'おすすめ',
        site_nav_search_recommend_bundle: 'おすすめセット',
        search_empty: 'コンテンツなし',
    },
    br: {
        search_delete: 'Excluir',
        site_nav_search: 'Pesquisar Ecoflow.com',
        site_nav_search_recommend: 'Recomendações',
        site_nav_search_recommend_bundle: 'Combos recomendados',
        search_empty: 'Nenhum conteúdo～',
    },
    mx: {
        search_delete: 'Borrar',
        site_nav_search: 'Buscar en Ecoflow.com',
        site_nav_search_recommend: 'Recomendaciones',
        site_nav_search_recommend_bundle: 'Paquetes recomendados',
        search_empty: 'Sin contenido～',
    },
};
export const formatOffText = (value: number, locale: string) => {
    const localeText = {
        us: `${value}% OFF`,
        de: `${value}% Rabatt`,
        fr: `${value}% OFF`,
        it: `Sconto ${value}%`,
        es: `Descuento${value}%`,
        jp: `${value}%OFF`,
        kr: `${value}% 할인`,
        br: `Descuento${value}%`,
        mx: `Descuento${value}%`,
        sa: `خصم  ${value}%`,
    };
    return localeText[locale as keyof typeof localeText] || localeText.us;
};
const DropBoxSearch = ({ callback, ...rest }: any) => {
    const router = useRouter();
    const { locale = '' } = getLocal();
    const [keyword, setKeyword] = useState<string | undefined>();
    const [listA, setList] = useState<any[]>([]);

    // const uuid: any = useRef<string>(sessionStorage.getItem('ef_search_ai_session_id') || ''); //  sessionId
    const uuid = useRef<string>(''); // 不要直接读 sessionStorage

    const userId = loginUser()?.user?.userId;
    const [isMobile, setIsMobile] = useState(false);
    const [showType, setShowType] = useState('');

    const handleQueryRecommendList = async (data?: any) => {
        try {
            const deviceId = await StatGetDeviceId({});

            const params = {
                sessionId: uuid?.current,
                triggerPage: 'Brand Search Recommend',
                tid: generateTraceId(),
                userId,
                deviceId: deviceId || '',
                ...data,
            };
            const productRes = await getGloAIProductList(params, locale);
            if (productRes?.code === '0') {
                let finalList = productRes?.data?.items;
                if (finalList?.length > 0) {
                    if (productRes?.data?.items?.length > 8 && finalList[0]?.itemType !== 'shopifyBundle') {
                        finalList = productRes?.data?.items?.slice(0, 8);
                    }
                    if (productRes?.data?.items?.length > 3 && finalList[0]?.itemType === 'shopifyBundle') {
                        finalList = productRes?.data?.items?.slice(0, 3);
                    }
                    setList(finalList || []);
                    setShowType(finalList[0]?.itemType);
                } else {
                    // TODO: 这里需要修改成 shopify 单品的接口
                    handleQueryProductList();
                }
            } else {
                handleQueryProductList();
            }
        } catch (error) {
            console.log(error);
        }
    };
    const closeFn = () => {
        EcoDesignEventsBus.emit('ef-header-search-close');
    };
    // const closeFn = () => callback && callback();

    const handleQueryProductList = async () => {
        const res = await queryShopifyProductList(locale);
        if (res?.code === '0') {
            const productList = res?.data || [];
            setShowType('shopifyProduct');
            handleFormatProductList(productList);
        } else {
        }
    };

    const handleFormatProductList = (productList: any[]) => {
        const formatList: any[] = [];
        productList.forEach((item: any) => {
            formatList.push({
                itemId: item?.variantId,
                itemType: 'shopifyProduct',
                variants: [item],
            });
        });

        setList(formatList?.slice(0, 8));
    };

    //  点击回车
    const onEnterHandle = (e: any) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            location.href = `/${locale}/search/${keyword}`;
            gtm.push({
                event: 'uaEvent',
                event_name: 'search_review',
                product_name: keyword,

                __btn_id1: 'header-search-input-v3',
                __btn_id2: 'header-search-input-v3',
                __btn_type: 'common',
            });
        }
    };

    const handleQueryVipData = async () => {
        let infoData = null;

        if (!!getIsLogin()) {
            const userInfoRes = await getAIUserInfo(locale as string);
            if (userInfoRes?.code === '0') {
                infoData = userInfoRes?.data;
            }

            await handleQueryRecommendList({ ...infoData });
        } else {
            await handleQueryRecommendList({});
        }
    };

    const handleItemClick = (item: any) => {
        sessionStorage.setItem('ai_recommend_module', 'AI Brand Search Recommend');

        // 新增 ai cookie 埋点
        const expires = new Date();
        expires.setDate(expires.getDate() + 7);

        const cookieOptions = {
            path: '/',
            domain: '.ecoflow.com',
            expires,
        };

        cookie.save('ai_entry_type', showType === 'shopifyProduct' ? 'AI Recommend Search_Shopify Product Page' : 'AI Recommend Search_Official Website Page', {
            path: '/',
            domain: '.ecoflow.com',
        });
        cookie.save('ai_jump_url', item?.url || `https://${locale}.ecoflow.com/products/${item?.handle}?variant=${item?.variantId}`, {
            path: '/',
            domain: '.ecoflow.com',
        });

        cookie.save(
            'display_type',
            showType === 'shopifyProduct' ? 'AI Recommend Search_Shopify Product Page' : 'AI Recommend Search_Official Website Page',
            cookieOptions,
        );

        gtm.push({
            event: 'uaEvent',
            event_name: 'search',
            search_term: 'none',
            button_name: item?.productName || item?.sceneTitle || item?.productTitle || item?.skuTitle || '',
            type: 'AI Recommend Search',
            display_type: showType === 'shopifyProduct' ? 'Shopify Product Page' : 'Official Website Page',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            uuid.current = sessionStorage.getItem('ef_search_ai_session_id') || '';
        }
        const isMobileValue = getIsPadWidth();
        setIsMobile(isMobileValue);
    }, []);

    useEffect(() => {
        if (!uuid.current) return;
        handleQueryVipData();

        return () => {
            setShowType('');
        };
    }, [uuid.current]);

    return (
        <div className={`${styles.searchbox} dropdown-inter`}>
            <div className="search-inner">
                <div className="searchbox-h">
                    <span className="searchbox-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <circle cx="11" cy="11" r="6" stroke="black" strokeWidth="1.6" />
                            <path
                                d="M19.3841 20.5154C19.6965 20.8279 20.203 20.8279 20.5154 20.5154C20.8279 20.203 20.8279 19.6965 20.5154 19.3841L19.9497 19.9497L19.3841 20.5154ZM15 15L14.4343 15.5657L19.3841 20.5154L19.9497 19.9497L20.5154 19.3841L15.5657 14.4343L15 15Z"
                                fill="black"
                            />
                        </svg>
                    </span>
                    <input
                        type="text"
                        className="searchbox-input header-search-input-v3 GtmModuleData-btn-common"
                        data-btn-id="header-search-input-v3"
                        onChange={(e) => setKeyword(e.target.value)}
                        onKeyUp={onEnterHandle}
                        placeholder={i18nText[locale]?.site_nav_search || i18nText.en.site_nav_search}
                    />
                    {!!isMobile && (
                        <span className="searchbox-del" aria-label={i18nText[locale]?.search_delete || i18nText.en.search_delete} onClick={closeFn}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M5 4.16663L15.8333 15M15.8333 4.16663L5 15"
                                    stroke="#010101"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    )}
                </div>
                <div className="searchbox-c">
                    <div className="searchbox-c-h">
                        {showType === 'shopifyBundle'
                            ? i18nText[locale]?.site_nav_search_recommend_bundle || i18nText.en.site_nav_search_recommend_bundle
                            : i18nText[locale]?.site_nav_search_recommend || i18nText.en.site_nav_search_recommend}
                    </div>
                    {(showType === 'scene' || showType === 'product' || showType === 'shopifyProduct') && (
                        <div className="searchbox-c-list">
                            {listA?.map((i: any) => {
                                const currentItem = showType === 'shopifyProduct' ? i?.variants?.[0] : i;
                                const imagesObj = i?.productImages && JSON.parse(i?.productImages);
                                const currentImages =
                                    showType === 'shopifyProduct'
                                        ? currentItem?.variantImg || currentItem?.img
                                        : imagesObj?.transparentImages ||
                                          imagesObj?.images ||
                                          imagesObj?.navigatorImages ||
                                          'https://websiteoss.ecoflow.com/upload/image/1755674891865/recommend_file.png';

                                return (
                                    <EcoLink
                                        className="searchbox-c-item"
                                        key={currentItem?.itemId || currentItem?.productId || currentItem?.variantId}
                                        href={
                                            currentItem?.url || `https://${locale}.ecoflow.com/products/${currentItem.handle}?variant=${currentItem.variantId}`
                                        }
                                        onClick={() => handleItemClick(currentItem)}
                                    >
                                        <EcoImg pc={currentImages} className="searchbox-c-item-img" />

                                        <div className="searchbox-c-item-info">
                                            {currentItem?.label && (
                                                <p className={`searchbox-c-item-tag searchbox-c-item-tag-${i.label}`}>{currentItem?.label || ''}</p>
                                            )}
                                            <p className="searchbox-c-item-title">
                                                {currentItem?.productName || currentItem?.sceneTitle || currentItem?.productTitle || currentItem?.skuTitle}
                                            </p>
                                            {currentItem?.price && (
                                                <div className="searchbox-c-item-price">
                                                    {currentItem?.price && (
                                                        <span className="searchbox-c-item-price1">{FormatMoneyLocal(currentItem?.price, locale)}</span>
                                                    )}
                                                    {currentItem?.compareAtPrice && (
                                                        <span className="searchbox-c-item-price2">{FormatMoneyLocal(currentItem?.compareAtPrice, locale)}</span>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </EcoLink>
                                );
                            })}
                            {listA?.length <= 0 && (
                                <button className="searchbox-c-item-empty">{i18nText[locale]?.search_empty || i18nText.en.search_empty}</button>
                            )}
                        </div>
                    )}
                    {showType === 'shopifyBundle' && (
                        <div className="searchbox-c-list searchbox-bundles-list">
                            {/* {searchRes?.items?.map((card: any) => { */}
                            {listA?.map((card: any) => {
                                return <EFBundlesCardAI key={card?.itemId} {...card} />;
                            })}
                            {listA?.length <= 0 && (
                                <button className="searchbox-c-item-empty">{i18nText[locale]?.search_empty || i18nText.en.search_empty}</button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DropBoxSearch;
